import { zVehicleModelCommonSchema } from "./vehicleModel.common";
// DTO схема для VehicleModel
export const zVehicleModelSchemaDto = zVehicleModelCommonSchema;
export const zVehicleModelSchemaCreateDto = zVehicleModelSchemaDto.omit({
    id: true,
});
